<template>
  <div id="app">
    <Header id="header"></Header>
    <div id="main">
      <router-view />
      <Footer></Footer>
      <GoTop></GoTop>
      <Service></Service>
      <!-- 绑定 visible 属性并监听 update:visible 事件 -->
      <JoinUs :visible.sync="showJoinUs" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      showJoinUs: false
    };
  },
  methods: {
    toggleJoinUs() {
      this.showJoinUs = !this.showJoinUs;
    }
  },
  created() {
    // 监听事件总线的消息
    this.$eventBus.$on('toggleJoinUs', this.toggleJoinUs);
  },
  beforeDestroy() {
    // 移除事件监听
    this.$eventBus.$off('toggleJoinUs', this.toggleJoinUs);
  }
};
</script>

<style scoped>
* {
  font-weight: 400;
}
#header {
  position: relative;
  z-index: 2;
}

#main {
  position: absolute;
  width: 100%;
  top: 0;
  z-index: 1;
}

@media screen and (max-width: 997px) {
  #header {
    position: relative;
  }

  #main {
    position: relative;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue